import { useCallback, useEffect, useRef, useState } from "react"

export const useAnnotationState = (activityId, isFocusShareActive) => {
    const [isDrawing, setIsDrawing] = useState(false)
    const [strokeCount, setStrokeCount] = useState(0)
    const [contentLayout, setContentLayout] = useState({ width: 0, height: 0 })
    const strokesRefsMap = useRef({})
    const materialCanvasRef = useRef(null)
    const imageActiveCanvasRef = useRef(null)
    const lastActiveCanvasRef = useRef(null)
    const whiteboardCanvasRef = useRef(null)

    const getStrokesRef = useCallback((key) => {
        const fullKey = `${activityId}_${key}`
        if (!strokesRefsMap.current[fullKey]) strokesRefsMap.current[fullKey] = { current: [] }
        return strokesRefsMap.current[fullKey]
    }, [activityId])

    const getImageStrokesRef = useCallback((imageIndex) => getStrokesRef(`image_${imageIndex}`), [getStrokesRef])

    const getActivityStrokeCount = useCallback(() => {
        return Object.entries(strokesRefsMap.current)
            .filter(([key]) => key.startsWith(`${activityId}_`))
            .reduce((sum, [, ref]) => sum + (ref.current?.length || 0), 0)
    }, [activityId])

    // Reset annotations when focus share stops (preserve whiteboard strokes)
    useEffect(() => {
        if (!isFocusShareActive) {
            setIsDrawing(false)
            const preserved = {}
            Object.entries(strokesRefsMap.current).forEach(([key, ref]) => {
                if (key.endsWith("_whiteboard")) preserved[key] = ref
            })
            strokesRefsMap.current = preserved
            setStrokeCount(getActivityStrokeCount())
        }
    }, [isFocusShareActive])

    // Redraw canvases when switching activities
    useEffect(() => {
        setStrokeCount(getActivityStrokeCount())
        materialCanvasRef.current?.redraw()
        imageActiveCanvasRef.current?.redraw()
        whiteboardCanvasRef.current?.redraw()
    }, [activityId])

    return {
        isDrawing, setIsDrawing,
        strokeCount, setStrokeCount,
        contentLayout, setContentLayout,
        materialCanvasRef, imageActiveCanvasRef, lastActiveCanvasRef, whiteboardCanvasRef,
        getStrokesRef, getImageStrokesRef, getActivityStrokeCount,
    }
}
